import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';

export default class WorkOrderExecutionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.shiftId  = '';
		this.shiftName = '';
		this.workOrderProcessDetailId  = '';
		this.workOrderProcessDetailPart = '';
		this.billOfProcessDetailId  = '';
		this.billOfProcessDetailSequence = '';
		this.subProcessNumber = '';
		this.lotNo = '';
		this.machineId  = '';
		this.machineCode = '';
		this.operatorUserName  = '';
		this.operatorFirstName = '';
		this.machineName = '';
		this.startProductionFrom = '';
		this.startProductionTo = '';
		this.finishProductionFrom = '';
		this.finishProductionTo = '';
		this.qtyPlan = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			shiftId : '0',
			shiftName : '0',
			workOrderProcessDetailId : '0',
			workOrderProcessDetailPart : '0',
			billOfProcessDetailId : '0',
			billOfProcessDetailSequence : '0',
			subProcessNumber : '0',
			lotNo : '0',
			machineId : '0',
			machineCode : '0',
			operatorId : '0',
			operatorFirstName : '0',
			machineName : '0',
			startProductionFrom : '0',
			startProductionTo : '0',
			finishProductionFrom : '0',
			finishProductionTo : '0',
			qtyPlan : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}